import React from 'react'
import { Button, Typography } from 'antd'
import { LockOutlined, UnlockOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Title, Text } = Typography

const BlockedSlotDisplay = ({ event, blockingActionBusy, handleBlockout, token }) => {
  return (
    <div style={{ padding: 16 }}>
      <div
        style={{
          background: hexToRGBA(token.colorError, 0.1),
          padding: 12,
          borderRadius: 4,
          marginBottom: 12,
          textAlign: 'center'
        }}
      >
        <LockOutlined style={{ fontSize: 24, color: token.colorError, marginBottom: 4 }} />
        <Title level={4} style={{ color: token.colorError, margin: 0, fontSize: '16px' }}>
          TIME SLOT BLOCKED
        </Title>
        <Text style={{ display: 'block', marginTop: 4, fontSize: '13px' }}>
          <strong>Reason:</strong> {event?.extendedProps?.blockReason}
        </Text>
      </div>

      <Button
        type='primary'
        icon={<UnlockOutlined />}
        loading={blockingActionBusy}
        onClick={() => handleBlockout(true)}
        style={{
          width: '100%',
          background: token.colorPrimary
        }}
        size='middle'
      >
        Unblock This Time Slot
      </Button>
    </div>
  )
}

export default BlockedSlotDisplay
